import { Check } from "lucide-react";

export const getPasswordRules = (password: string) => [
  { label: "8 characters", isMet: password.length >= 8 },
  { label: "1 lowercase letter", isMet: /[a-z]/.test(password) },
  { label: "1 uppercase letter", isMet: /[A-Z]/.test(password) },
  { label: "1 number", isMet: /\d/.test(password) },
  {
    label: "1 special character (e.g. ! _ @ # ?)",
    isMet: /[^A-Za-z0-9]/.test(password),
  },
];

interface PasswordRequirementProps {
  label: string;
  isMet: boolean;
}
const PasswordRequirement = ({ label, isMet }: PasswordRequirementProps) => (
  <div className="flex items-center gap-2">
    {isMet ? (
      <Check className="text-success-600" size={16} />
    ) : (
      <div className="flex size-4 items-center">
        <div className="size-1 rounded-full bg-primary-500" />
      </div>
    )}
    <p className="font-medium text-primary-950">{label}</p>
  </div>
);

export const PasswordRequirements = ({ password }: { password: string }) => {
  return (
    <div className="flex flex-col gap-3 rounded-xl bg-primary-50 p-4">
      <p className="text-primary-950">Must have at least:</p>
      <ul className="flex flex-col gap-1">
        {getPasswordRules(password).map((rule) => {
          return (
            <PasswordRequirement
              key={rule.label}
              label={rule.label}
              isMet={rule.isMet}
            />
          );
        })}
      </ul>
    </div>
  );
};
